"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getScriptLoader;
var create_script_loader_1 = require("./create-script-loader");
var instance;
function getScriptLoader() {
    if (!instance) {
        instance = (0, create_script_loader_1.default)();
    }
    return instance;
}
//# sourceMappingURL=get-script-loader.js.map